import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Payment, PaymentCreate, PaymentFilter } from '../data/payment';

export function createPaymentService(client: AxiosInstance) {
  return createCrudService<Payment, PaymentCreate, PaymentFilter>(client, '/Payment', 'paymentId');
}

export type PaymentService = CrudService<Payment, PaymentCreate, PaymentFilter>;
